import { useToast } from '@chakra-ui/react'
import { createContext, useContext, useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useLocation, useNavigate } from 'react-router-dom'

import { authRouteNames } from '@/ui/routes/routesNames/authRouteNames'

const forgotPasswordContext = createContext<{
  userCode?: string
  setUserCode: (code: string) => void
  userDoc?: string
  setUserDoc: (doc: string) => void
  email?: string
  setEmail: (email: string) => void
  userName?: string
  setUserName: (name: string) => void
}>({
  setUserCode: () => ({}),
  setUserDoc: () => ({}),
  setEmail: () => ({}),
  setUserName: () => ({})
})

export const useForgotPasswordContext = () => useContext(forgotPasswordContext)

export default function ForgotPasswordProvider({
  children
}: {
  children: React.ReactNode
}) {
  const toast = useToast()
  const navigate = useNavigate()
  const { t } = useTranslation()
  const location = useLocation()

  const [userDoc, setUserDoc] = useState<string | undefined>()
  const [userCode, setUserCode] = useState<string | undefined>()
  const [email, setEmail] = useState<string | undefined>()
  const [userName, setUserName] = useState<string | undefined>()

  useEffect(() => {
    if (
      location.pathname !== authRouteNames.forgotPassword &&
      location.pathname !== authRouteNames.forgotLogin &&
      !userDoc
    ) {
      toast({
        description: t('auth.changePassword.invalidDocument'),
        status: 'error'
      })
      navigate(authRouteNames.login)
    }
    if (location.pathname === authRouteNames.changePassword && !userCode) {
      toast({
        description: t('auth.changePassword.invalidCode'),
        status: 'error'
      })
      navigate(authRouteNames.login)
    }
  }, [userDoc, userCode])

  return (
    <forgotPasswordContext.Provider
      value={{
        userCode,
        setUserCode,
        userDoc,
        setUserDoc,
        email,
        setEmail,
        userName,
        setUserName
      }}
    >
      {children}
    </forgotPasswordContext.Provider>
  )
}
